import { EditorView, showTooltip } from "@codemirror/view";
import { StateField, StateEffect } from "@codemirror/state";
import functions from "./functions";

const functionNames = functions.map((f) => f.value);

function isInsideFunction(pos, doc) {
  const text = doc.toString();

  let textBeforePos = "";
  let functionStack = [];
  let insideString = false;

  for (let i = 0; i < pos; i++) {
    textBeforePos += text[i];

    for (let i = 0; i < functionNames.length; i++) {
      if (textBeforePos.endsWith(`${functionNames[i]}(`)) {
        functionStack.push({
          name: functionNames[i],
          arg: 1,
          argPos: 0,
        });
      }
    }

    if (functionStack.length && text[i] === '"') {
      insideString = !insideString;
    }

    if (functionStack.length && !insideString && text[i] === ",") {
      functionStack[functionStack.length - 1].arg++;
      functionStack[functionStack.length - 1].argPos = 0;
    } else if (
      functionStack.length &&
      // Don't increase the arg position if the cursor is at the very beginning of the function.
      !(functionStack[functionStack.length - 1].argPos === 0 && text[i] === "(")
    ) {
      functionStack[functionStack.length - 1].argPos++;
    }

    if (functionStack.length && !insideString && text[i] === ")") {
      functionStack.pop();
    }
  }

  return functionStack.length ? functionStack[functionStack.length - 1] : null;
}

export const clearTooltipsEffect = StateEffect.define();

export function createFunctionTooltipField(onArgChange, onArgStart) {
  let previousArg = null;

  return StateField.define({
    create() {
      return null;
    },
    update(value, tr) {
      if (tr.effects.some((e) => e.is(clearTooltipsEffect))) {
        return null;
      }

      if (!tr.docChanged && !tr.selection) return value;

      const pos = tr.state.selection.main.head;
      const isInside = isInsideFunction(pos, tr.state.doc);

      if (isInside) {
        if (isInside.argPos === 0) {
          onArgStart();
        }

        if (previousArg !== isInside.arg) {
          previousArg = isInside.arg;
          onArgChange();
        }

        const tooltip = {
          pos,
          above: true,
          strictSide: false,
          create() {
            const func = functions.find((f) => f.value === isInside.name);

            let dom = document.createElement("div");
            dom.append(`${func.value}(`);

            func.args.forEach((arg, i) => {
              let span = document.createElement("span");
              span.className = isInside.arg === i + 1 ? "active-arg" : "";
              span.textContent = arg;

              dom.appendChild(span);

              if (func.args.length - 1 !== i) {
                dom.append(", ");
              }
            });
            dom.append(")");

            dom.className = "cm-tooltip cm-tooltip-function";
            return { dom };
          },
        };
        return tooltip;
      }

      return null;
    },
    provide: (f) => showTooltip.from(f),
  });
}

export const functionTooltipTheme = EditorView.baseTheme({
  ".cm-tooltip.cm-tooltip-function": {
    backgroundColor: "#fff",
    color: "#000",
    padding: "4px 8px",
    fontWeight: "bold",
    borderRadius: "4px",
    zIndex: 10,

    "& > span": {
      fontWeight: "normal",
    },
  },

  ".cm-tooltip.cm-tooltip-function .active-arg": {
    backgroundColor: "#30A689",
    color: "#fff",
  },
});
